import _regeneratorRuntime from "babel-runtime/regenerator";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { useRef } from "react";
import { Card, Nav, Tab, Button, ProgressBar } from "react-bootstrap";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./index.css";
var stepRefs = {};
var ReactWizard = function ReactWizard(props) {
  props.steps.forEach(function (step) {
    if (!stepRefs[step.stepName]) {
      stepRefs[step.stepName] = useRef();
    }
  });

  return React.createElement(Wizard, _extends({}, props, { stepRefs: stepRefs }));
};

var StepProgress = function StepProgress(_ref) {
  var steps = _ref.steps,
      currentStep = _ref.currentStep,
      highestStep = _ref.highestStep,
      color = _ref.color,
      stepButtonClasses = _ref.stepButtonClasses;

  var progressValue = 0;
  switch (currentStep) {
    case 0:
      {
        progressValue = 0;
        break;
      }
    case steps.length - 1:
      {
        progressValue = 100;
        break;
      }

    default:
      {
        progressValue = currentStep / (steps.length - 1) * 100;
      }
  }
  return React.createElement(
    "div",
    null,
    React.createElement(
      "div",
      { className: "d-flex d-flex-row step-container align-items-center" },
      steps.map(function (prop, key) {
        return React.createElement(
          React.Fragment,
          null,
          React.createElement(
            "div",
            null,
            React.createElement(
              "div",
              { className: "d-flex d-flex-row step-progress align-items-center" },
              React.createElement(
                Nav.Link,
                {
                  eventKey: key,
                  className: "d-inline rounded-circle " + (stepButtonClasses ? stepButtonClasses : "") + " " + (key === currentStep || key <= highestStep ? " active text-white checked bg-" + color : "text-" + color + " border-" + color)
                },
                key === currentStep || key <= highestStep ? React.createElement(
                  "span",
                  null,
                  React.createElement("img", { src: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17.415' height='13.259' viewBox='0 0 17.415 13.259'%3E%3Cpath d='M10.641,18.889,6.485,14.733,5.1,16.118l5.541,5.541L22.515,9.785,21.13,8.4Z' transform='translate(-5.1 -8.4)' fill='%23fff'/%3E%3C/svg%3E" })
                ) : prop.stepIcon !== undefined && prop.stepIcon !== "" ? React.createElement("i", { className: prop.stepIcon }) : React.createElement(
                  "span",
                  null,
                  key + 1
                )
              ),
              React.createElement(
                "div",
                { className: "step-name" },
                prop.stepName
              )
            )
          ),
          key < steps.length - 1 && React.createElement(
            "div",
            { className: "flex-fill " },
            React.createElement(
              "div",
              { className: "progress-container px-1" },
              React.createElement(ProgressBar, {
                now: key <= currentStep - 1 ? 100 : 0,
                variant: color
              })
            )
          )
        );
      })
    )
  );
};

var Wizard = function (_React$Component) {
  _inherits(Wizard, _React$Component);

  function Wizard(props) {
    var _this2 = this;

    _classCallCheck(this, Wizard);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.nextButtonClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var key;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.props.validate && (_this.props.stepRefs[_this.props.steps[_this.state.currentStep].stepName].current.isValidated !== undefined && _this.props.stepRefs[_this.props.steps[_this.state.currentStep].stepName].current.isValidated() || _this.props.stepRefs[_this.props.steps[_this.state.currentStep].stepName].current.isValidated === undefined) || _this.props.validate === undefined || !_this.props.validate)) {
                _context.next = 12;
                break;
              }

              _context.prev = 1;

              if (!_this.props.stepRefs[_this.props.steps[_this.state.currentStep].stepName].current.onClickNext) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return _this.props.stepRefs[_this.props.steps[_this.state.currentStep].stepName].current.onClickNext();

            case 5:
              key = _this.state.currentStep + 1;

              _this.setState({
                currentStep: key,
                highestStep: key > _this.state.highestStep ? key : _this.state.highestStep,
                nextButton: _this.props.steps.length > key + 1 ? true : false,
                previousButton: key > 0 ? true : false,
                finishButton: _this.props.steps.length === key + 1 ? true : false
              });
              _this.refreshAnimation(key);
              _context.next = 12;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[1, 10]]);
    }));

    _this.previousButtonClick = function () {
      var key = _this.state.currentStep - 1;
      if (key >= 0) {
        _this.setState({
          currentStep: key,
          highestStep: key > _this.state.highestStep ? key : _this.state.highestStep,
          nextButton: _this.props.steps.length > key + 1 ? true : false,
          previousButton: key > 0 ? true : false,
          finishButton: _this.props.steps.length === key + 1 ? true : false
        });
        _this.refreshAnimation(key);
      }
    };

    _this.finishButtonClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this.props.validate === false && _this.props.finishButtonClick !== undefined || _this.props.validate && (_this.props.stepRefs[_this.props.steps[_this.state.currentStep].stepName].current.isValidated !== undefined && _this.props.stepRefs[_this.props.steps[_this.state.currentStep].stepName].current.isValidated() || _this.props.stepRefs[_this.props.steps[_this.state.currentStep].stepName].current.isValidated === undefined) && _this.props.finishButtonClick !== undefined)) {
                _context2.next = 12;
                break;
              }

              _context2.prev = 1;
              response = null;

              if (!_this.props.stepRefs[_this.props.steps[_this.state.currentStep].stepName].current.onClickNext) {
                _context2.next = 7;
                break;
              }

              _context2.next = 6;
              return _this.props.stepRefs[_this.props.steps[_this.state.currentStep].stepName].current.onClickNext();

            case 6:
              response = _context2.sent;

            case 7:

              _this.props.finishButtonClick(response);
              _context2.next = 12;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[1, 10]]);
    }));


    _this.state = {
      currentStep: 0,
      highestStep: 0,
      color: _this.props.color !== undefined ? _this.props.color : "primary",
      nextButton: _this.props.steps.length > 1 ? true : false,
      previousButton: false,
      finishButton: _this.props.steps.length === 1 ? true : false

      // movingTabStyle: {
      //     transition: "transform 0s"
      // }
    };

    _this.navigationStepChange = _this.navigationStepChange.bind(_this);
    _this.refreshAnimation = _this.refreshAnimation.bind(_this);
    _this.previousButtonClick = _this.previousButtonClick.bind(_this);
    _this.previousButtonClick = _this.previousButtonClick.bind(_this);
    _this.finishButtonClick = _this.finishButtonClick.bind(_this);
    return _this;
  }

  Wizard.prototype.componentDidMount = function componentDidMount() {
    this.refreshAnimation(0);
    window.addEventListener("resize", this.updateWidth.bind(this));
  };

  Wizard.prototype.componentWillUnmount = function componentWillUnmount() {
    var ctx = this;
    //Reset components if wizard close
    this.props.steps.forEach(function (step) {
      if (ctx.props.stepRefs[step.stepName] && ctx.props.stepRefs[step.stepName].current.reset) {
        ctx.props.stepRefs[step.stepName].current.reset();
      }
    });

    this.isCancelled = true;
    window.removeEventListener("resize", this.updateWidth);
    var id = window.setTimeout(null, 0);
    while (id--) {
      window.clearTimeout(id);
    }
  };

  Wizard.prototype.updateWidth = function updateWidth() {
    var _this3 = this;

    !this.isCancelled && setTimeout(function () {
      return _this3.refreshAnimation(_this3.state.currentStep);
    }, 200);
  };

  Wizard.prototype.navigationStepChange = function navigationStepChange(key) {
    if (this.props.navSteps) {
      var validationState = true;
      if (this.props.validate && key > this.state.currentStep) {
        for (var i = this.state.currentStep; i < key; i++) {
          if (this.props.stepRefs[this.props.steps[i].stepName].current.isValidated !== undefined && this.props.stepRefs[this.props.steps[i].stepName].current.isValidated() === false) {
            validationState = false;
            break;
          }
        }
      }
      if (validationState) {
        this.setState({
          currentStep: key,
          highestStep: key > this.state.highestStep ? key : this.state.highestStep,
          nextButton: this.props.steps.length > key + 1 ? true : false,
          previousButton: key > 0 ? true : false,
          finishButton: this.props.steps.length === key + 1 ? true : false
        });
        this.refreshAnimation(key);
      }
    }
  };

  Wizard.prototype.refreshAnimation = function refreshAnimation(index) {
    var total = this.props.steps.length;
    var li_width = 100 / total;

    // var total_steps =
    //     this.props.steps !== undefined ? this.props.steps.length : 0;
    // var move_distance =
    //     this.refs.wizard !== undefined
    //         ? this.refs.navStepsLi.children[0].clientWidth / total_steps
    //         : 0;
    // var index_temp = index;
    var vertical_level = 0;

    var mobile_device = window.innerWidth < 600 && total > 3;

    if (mobile_device) {
      // move_distance = this.refs.navStepsLi.children[0].clientWidth / 2;
      index_temp = index % 2;
      li_width = 50;
    }

    this.setState({ width: li_width + "%" });

    // var step_width = move_distance;

    // move_distance = move_distance * index_temp;

    if (mobile_device) {
      vertical_level = parseInt(index / 2);
      vertical_level = vertical_level * 38;
    }

    // var movingTabStyle = {
    //     width: step_width,
    //     transform:
    //         "translate3d(" + move_distance + "px, " + vertical_level + "px, 0)",
    //     transition: "all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)"
    // };
    // this.setState({
    //     movingTabStyle: movingTabStyle
    // });
  };

  Wizard.prototype.render = function render() {
    var _this4 = this,
        _classnames,
        _classnames2,
        _classnames3;

    return React.createElement(
      "div",
      { className: "wizard-container", ref: "wizard" },
      React.createElement(
        "div",
        { className: "card-wizard active", variant: this.state.color },
        React.createElement(
          Tab.Container,
          {
            id: "left-tabs-example",
            defaultActiveKey: "0",
            activeKey: this.state.currentStep,
            onSelect: function onSelect(k) {
              return _this4.navigationStepChange(k);
            }
          },
          React.createElement(
            "div",
            {
              className: this.props.headerTextCenter !== undefined ? "mx-5 text-center" : "mx-5",
              "data-background-color": this.state.color
            },
            this.props.title !== undefined ? React.createElement(
              Card.Title,
              { tag: "h3" },
              this.props.title
            ) : null,
            this.props.description !== undefined ? React.createElement(
              "h3",
              { className: "description" },
              this.props.description
            ) : null,
            React.createElement(
              "div",
              { className: "wizard-navigation", ref: "navStepsLi" },
              React.createElement(StepProgress, {
                steps: this.props.steps,
                currentStep: this.state.currentStep,
                highestStep: this.state.highestStep,
                color: this.props.color,
                stepButtonClasses: this.props.stepButtonClasses
              })
            )
          ),
          React.createElement(
            Tab.Content,
            { className: "my-5" },
            this.props.steps.map(function (prop, key) {
              var Component = React.forwardRef(prop.component);
              return React.createElement(
                Tab.Pane,
                {
                  eventKey: key,
                  key: key,
                  className: classnames("fade", {
                    show: _this4.state.currentStep === key
                  })
                },
                typeof prop.component === "function" || _typeof(prop.component) === "object" ? React.createElement(Component, _extends({
                  ref: stepRefs[prop.stepName]
                }, prop.stepProps)) : React.createElement(
                  "div",
                  { ref: prop.stepName },
                  prop.component
                )
              );
            })
          ),
          React.createElement(
            "div",
            { style: { float: "right" } },
            this.state.previousButton ? React.createElement(
              Button,
              {
                className: classnames((_classnames = {}, _classnames[this.props.previousButtonClasses] = this.props.previousButtonClasses !== undefined, _classnames)),
                onClick: this.previousButtonClick,
                variant: "outline-" + this.props.color,
                disabled: this.props.disabled
              },
              this.props.previousButtonText !== undefined ? this.props.previousButtonText : "Previous"
            ) : null,
            this.state.nextButton ? React.createElement(
              Button,
              {
                className: classnames("ml-3", (_classnames2 = {}, _classnames2[this.props.nextButtonClasses] = this.props.nextButtonClasses !== undefined, _classnames2)),
                onClick: this.nextButtonClick,
                variant: this.props.color,
                disabled: this.props.disabled
              },
              this.props.nextButtonText !== undefined ? this.props.nextButtonText : "Next"
            ) : null,
            this.state.finishButton ? React.createElement(
              Button,
              {
                className: classnames("ml-3", (_classnames3 = {}, _classnames3[this.props.finishButtonClasses] = this.props.finishButtonClasses !== undefined, _classnames3)),
                onClick: this.finishButtonClick,
                variant: this.props.color,
                disabled: this.props.disabled
              },
              this.props.finishButtonText !== undefined ? this.props.finishButtonText : "Finish"
            ) : null
          )
        )
      )
    );
  };

  return Wizard;
}(React.Component);

Wizard.defaultProps = {
  validate: false,
  previousButtonText: "Previous",
  finishButtonText: "Finish",
  nextButtonText: "Next",
  color: "primary",
  stepButtonClasses: "px-3 rounded"
};

ReactWizard.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.oneOf(["primary", "secondary", "info", "warning", "danger", "success"]),
  previousButtonClasses: PropTypes.string,
  finishButtonClasses: PropTypes.string,
  nextButtonClasses: PropTypes.string,
  stepButtonClasses: PropTypes.string,
  headerTextCenter: PropTypes.bool,
  navSteps: PropTypes.bool,
  validate: PropTypes.bool,
  finishButtonClick: PropTypes.func,
  previousButtonText: PropTypes.node,
  finishButtonText: PropTypes.node,
  nextButtonText: PropTypes.node,
  title: PropTypes.node,
  description: PropTypes.node,
  steps: PropTypes.arrayOf(PropTypes.shape({
    stepName: PropTypes.string.isRequired,
    stepIcon: PropTypes.string,
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
    stepProps: PropTypes.object
  })).isRequired,
  //**Disable buttons */
  disabled: PropTypes.bool
} : {};

export default ReactWizard;